import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../../../core/auth/auth.service';

export const restaurantAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const decision = () => auth.canViewRestaurantOrders() || router.createUrlTree(['/profile']);
  return auth.isInitializing()
    ? toObservable(auth.isInitializing).pipe(
        filter((initializing) => !initializing),
        take(1),
        map(decision),
      )
    : decision();
};
